import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';

/** French first: it is the project's primary language and the fallback. */
export const SUPPORTED_LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

function withoutQuestions(bundle: Record<string, unknown>): Record<string, unknown> {
  const { questions: _questions, ...rest } = bundle;
  return rest;
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      // Questions are deliberately withheld from i18next: they are addressed by
      // stable id, and i18next can only reach an array by position. They are
      // read directly from the JSON in `questionBank.ts` instead.
      fr: { translation: withoutQuestions(fr) },
      en: { translation: withoutQuestions(en) },
    },
    // French is the primary language: an English browser still gets English via
    // detection, but anything else lands on French rather than English.
    fallbackLng: 'fr',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    // Locale variants (en-GB, fr-CA…) should resolve to their base bundle.
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'mr.lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
